import { render, staticRenderFns } from "./Trend.vue?vue&type=template&id=3c54eff5&scoped=true&"
import script from "./Trend.vue?vue&type=script&lang=js&"
export * from "./Trend.vue?vue&type=script&lang=js&"
import style0 from "./Trend.vue?vue&type=style&index=0&id=3c54eff5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c54eff5",
  null
  
)

component.options.__file = "Trend.vue"
export default component.exports